<template>
  <div class="container">
    <div class="version-view">
      <h1>Project Log</h1>
      <div class="version-1-dot-0">
        <h3>Version 1.0 (Milestone 1)</h3>
        <dl>
          <dt>Log in</dt>
          <dd>To Allow Users to Log in</dd>
          <dt>Register User</dt>
          <dd>To Allow Users to Register</dd>
          <dt>Forgot Password</dt>
          <dd>To Allow Users to Reset Password</dd>
          <dt>Account Overview</dt>
          <dd>To Allow Users to SignOut and View Profile</dd>
          <dt>Mobile Support</dt>
          <dd>To Allow Users to Use Our Website on a Smartphone</dd>
          <dt>Navigation Bar</dt>
          <dd>To Allow Users to Navigate Easily</dd>
        </dl>
      </div>
      <div class="version-1-dot-1">
        <h3>Version 1.1 (Milestone 2)</h3>
        <dl>
          <dt>Project Log</dt>
          <dd>To Allow Users to See Our Implementation Roadmap</dd>
          <dt>Order Now</dt>
          <dd>To Allow Users to Place Their Orders</dd>
          <dt>Become a Saviour</dt>
          <dd>To Allow Users to Help Others</dd>
          <dt>Profile View</dt>
          <dd>To Allow Users to Look at their Profile and Edit Particulars</dd>
          <dt>Cart View</dt>
          <dd>To Allow Users to Look at the Items in their Cart</dd>
          <dt>Footer</dt>
          <dd>To Allow Users to Look at Footer for Some Reference Links</dd>
          <dt>Order Summary</dt>
          <dd>
            To Allow Users to Look at The Order Placed Details, As Well As Their
            Saviour
          </dd>
          <dt>Error 404</dt>
          <dd>To Alert Users Incase of Unspecified Links/Paths</dd>
          <dt>Dashboard</dt>
          <dd>
            To Allow Users to Have a Look at The Summary View of Their Account.
            Users Can Look at their <br />Previous Orders, Cart and There are
            Quick Action Buttons to go to Track Their Placed Order and/or
            Saviour Status.
          </dd>
        </dl>
      </div>
      <div class="version-1-dot-1-m3">
        <h3>Version 1.1 (Milestone 3)</h3>
        <dl>
          <dt>Dashboard</dt>
          <dd>Refinements</dd>
          <dt>Quick Place Order</dt>
          <dd>
            To Allow Users to Quickly Replace An Order That They Have Placed
            Earlier
          </dd>
          <dt>Admin</dt>
          <dd>To Allow Admins to View The Activities Going On...</dd>
          <dt>Terms And Conditions For Saviour</dt>
          <dd>
            To Allow Users to View The Terms And Conditions Once They Are A
            Saviour
          </dd>
          <dt>User Interface Changes</dt>
          <dd>To Allow Users to Navigate Seamlessly</dd>
          <dt>Bug Fixes</dt>
          <dd>To Further Enhance User Experience</dd>
          <dt>System Testing</dt>
          <dd>To Hunt For Bugs And Other Issues</dd>
        </dl>
      </div>
      <div class="version-1-dot-1-pm3">
        <h3>Version 1.1 (Post Milestone 3)</h3>
        <dl>
          <dt>Home Page</dt>
          <dd>Revamped The Look Of The Home Page</dd>
          <dt>Live Order Status</dt>
          <dd>
            To Allow Users To Track The Order They Have Placed. Users Would Get
            Messages Like:
            <ol>
              <li>Order Has Been Accepted</li>
              <li>Order Has Been Placed At The Desired Restaurant</li>
              <li>Order Has Been Picked Up</li>
              <li>Order Is En Route</li>
            </ol>
          </dd>
          <dt>Bug Fixes</dt>
          <dd>To Further Enhance User Experience</dd>
          <dt>System Testing</dt>
          <dd>To Hunt For Bugs And Other Issues</dd>
          <dt>U.I. Enhancements</dt>
          <dd>Added Memes and Backgrounds to Various Pages</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectLog",
};
</script>

<style lang="scss" scoped>
dt {
  font-weight: bold;
  padding-left: 15px;
}

dd,
ol {
  font-style: italic;
  padding-bottom: 10px;
  padding-left: 25px;
}
.container {
  background: url("../assets/background/background9.jpeg");
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  //height: 920px;
  //background-size: 100% 100%;
  //height: 1000px;
  //width: 5000px;
  //display: flex;
  //flex-direction: column;

  h1 {
    text-align: center;
    color: crimson;
  }

  h3 {
    color: indianred;
    padding: 18px 0;
    padding-left: 15px;
  }

  .version-view {
    display: flex;
    flex-direction: column;

    .version-1-dot-0 {
      flex: 1;
    }

    .version-1-dot-1 {
      flex: 1;
    }

    .version-1-dot-1-m3 {
      flex: 1;
    }

    .version-1-dot-1-pm3 {
      flex: 1;
    }
  }
}
</style>
